import React, { useState } from 'react';
import BookingModal from './BookingModal';
import { useLockBodyScroll } from '../utils/useLockBodyScroll';

const ReserveSpotModal = ({ isOpen, onClose, tour }) => {
  const [showBookingModal, setShowBookingModal] = useState(false);

  useLockBodyScroll(isOpen);

  if (!isOpen || !tour) return null;

  return (
    <>
      <div className="modal active" onClick={onClose}>
        <div className="modal-content bg-white rounded-2xl shadow-2xl max-w-2xl w-full mx-4" onClick={(e) => e.stopPropagation()}>
          <div className="bg-gradient-to-r from-brand-teal to-brand-cyan text-white p-6 rounded-t-2xl">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="text-3xl font-bold mb-2">Reserve Your Spot</h3>
                <p className="text-green-100">{tour.name}</p>
              </div>
              <button onClick={onClose} className="text-white hover:text-gray-200 text-3xl transform hover:rotate-90 transition">
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>
          
          <div className="p-8">
            <div className="mb-6">
              <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-xl p-6 mb-6">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <p className="text-gray-600 text-sm mb-1">Tour Price</p>
                    <p className="text-4xl font-bold bg-gradient-to-r from-brand-teal to-brand-cyan bg-clip-text text-transparent">{tour.price}</p>
                    <p className="text-gray-500 text-sm">per person</p>
                  </div>
                  <div className="text-right">
                    <p className="text-gray-600 text-sm mb-1">Spots Available</p>
                    <p className="text-2xl font-bold text-brand-teal">{tour.spotsAvailable}</p>
                  </div>
                </div>
                <div className="border-t border-gray-300 pt-4">
                  <p className="text-gray-700 mb-2"><i className="fas fa-calendar-alt text-brand-teal mr-2"></i><strong>Departure:</strong> {tour.departureDate}</p>
                  <p className="text-gray-700"><i className="fas fa-clock text-brand-teal mr-2"></i><strong>Duration:</strong> {tour.duration}</p>
                </div>
              </div>
              
              <p className="text-gray-600 mb-6">
                This tour is departing soon with limited availability. Reserve your spot now to secure your place on this amazing adventure!
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => {
                  setShowBookingModal(true);
                  onClose();
                }}
                className="flex-1 bg-gradient-to-r from-brand-teal to-brand-cyan text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-xl transition transform hover:scale-105"
              >
                <i className="fas fa-calendar-check mr-2"></i>Continue to Booking
              </button>
              <button 
                type="button" 
                onClick={onClose} 
                className="flex-1 bg-gray-200 text-gray-700 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-300 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <BookingModal 
        isOpen={showBookingModal}
        onClose={() => setShowBookingModal(false)}
        tourName={tour.name}
        tourPrice={tour.price}
        tourId={tour._id || null}
      />
    </>
  );
};

export default ReserveSpotModal;

